import Card from 'react-bootstrap/Card';
import elyisa_logo from '../../assets/Elysia-logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleUp,
  faAngleDown,
  faArrowUpRightFromSquare,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import { Collapse, ListGroup } from 'react-bootstrap';
import { getFavicon } from '@/utils/url';

interface IntermediateStepsProps {
  toolResults: any;
  toolCall: any;
  siteCount: number;
  showSource: boolean;
  message: string;
  mouseOverIndex: number | null;
  imageId?: string;
  setShowSource: (arg) => void;
  handleKeyPress: (arg) => void;
  setmouseOverIndex: (arg) => void;
}

const IntermediateSteps = ({
  toolCall,
  toolResults,
  siteCount,
  showSource,
  setShowSource,
  mouseOverIndex,
  message,
  imageId,
  handleKeyPress,
  setmouseOverIndex,
}: IntermediateStepsProps) => {
  return (
    <>
      <Card.Title>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <img
              className="sys-msg-card-img"
              data-testid="sys-msg-elysia-image"
              src={elyisa_logo}
              alt="Elysia"
            />
          </div>
          {!message && !toolResults?.length && toolCall && !imageId ? (
            <div className="searching-placeholder">
              {toolCall !== 'Document' ? (
                <span>{toolCall}</span>
              ) : (
                <span>Retrieving information</span>
              )}
            </div>
          ) : null}
          {siteCount > 0 ? (
            <div>
              <div
                tabIndex={0}
                className="source-interaction-btn"
                onClick={() => setShowSource((prev) => !prev)}
                onKeyUp={(e) => handleKeyPress(e)}
              >
                Searched {siteCount} sites &nbsp;
                <FontAwesomeIcon icon={showSource ? faAngleUp : faAngleDown} />
              </div>
            </div>
          ) : null}
        </div>
      </Card.Title>
      <Collapse in={showSource} timeout={1000}>
        <div className="pb-4">
          <ListGroup>
            {toolResults?.length &&
              toolResults.map((sObj, inx) => {
                if (sObj?.toolcall) {
                  const searchURL = encodeURI(`https://www.google.com/search?q=${sObj?.searching}`);
                  return (
                    <ListGroup.Item
                      key={`searching_${inx}`}
                      as="a"
                      active={false}
                      href={searchURL}
                      target="_blank"
                      className="d-flex justify-content-between align-items-start source-list-item"
                      onMouseEnter={() => setmouseOverIndex(inx)}
                      onMouseLeave={() => setmouseOverIndex(null)}
                      title={searchURL}
                    >
                      <div className="d-flex align-items-center source-item-container">
                        <FontAwesomeIcon className="source-img" icon={faMagnifyingGlass} />
                        <div className="source-item">"{sObj.searching}"</div>
                      </div>
                      {mouseOverIndex === inx && (
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                      )}
                    </ListGroup.Item>
                  );
                }
                if (!sObj.source) {
                  return null; // Skip items with null source
                }
                let url;
                try {
                  url = new URL(sObj.source);
                } catch (error) {
                  console.warn('Invalid URL:', sObj.source, error);
                  return null; // Skip items with invalid URLs
                }
                return (
                  <ListGroup.Item
                    key={`${url.hostname}_${inx}`}
                    as="a"
                    active={false}
                    href={sObj.source}
                    target="_blank"
                    className="d-flex justify-content-between align-items-start source-list-item"
                    onMouseEnter={() => setmouseOverIndex(inx)}
                    onMouseLeave={() => setmouseOverIndex(null)}
                    title={sObj.source}
                  >
                    <div className="d-flex align-items-center source-item-container">
                      <img
                        alt={url.hostname}
                        className="source-img"
                        src={getFavicon(url)}
                        aria-hidden="true"
                      />
                      <div className="source-item">{sObj.source}</div>
                    </div>
                    {mouseOverIndex === inx && <FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
                  </ListGroup.Item>
                );
              })}
          </ListGroup>
        </div>
      </Collapse>
    </>
  );
};

export default IntermediateSteps;
